import React from 'react';
import Markdown from 'utils/markdownToComponent';
import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';
import { breakpoint } from 'utils/mediaQueries';
import { colors } from 'styles';

const ContentText = styled(Grid)`
  width: 100%;
  ${breakpoint.down('md')`
  text-align:center; justify-content:center`};
`;
const Subtitle = styled(Typography)`
  ${breakpoint.down('md')`
  padding-bottom: 8rem;
  font-size: ${props => `${props.theme.typography.h5.fontSize}
px`};`};
  ${breakpoint.down('sm')`
  padding-bottom: 5rem;
    font-size: ${props => `${props.theme.typography.h6.fontSize}px`}`};
  ${breakpoint.only('xxs')`
  padding-bottom: 8rem;
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};
  `};
  span {
    color: ${colors.purple};
  }
`;
const StyledMarkdown = styled(Markdown)`
  padding-top: 2rem;
  margin: 0;
  width: 60%;
  ${breakpoint.down('lg')`
    width:85%;
   `};
  ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}
px`};padding:2rem; width:75%;`};
  ${breakpoint.down('sm')`
    width:100%;padding:0; padding-top: 2rem`};
  ${breakpoint.down('xs')`  
  font-size: ${props => `${props.theme.typography.body2.fontSize}
px`};`};
  ${breakpoint.only('xxs')`
  padding-top: 0;margin-top:-2rem;
  `};
`;
const BlockText = ({ markdownContent }) => {
  return (
    <ContentText
      container
      item
      xs={12}
      sm={12}
      md={9}
      lg={11}
      alignItems="center"
      justify="flex-start"
    >
      <Subtitle
        variant="h1"
        dangerouslySetInnerHTML={{
          __html: markdownContent.frontmatter.subTitle,
        }}
        id="titleIntroBlock"
      />
      <StyledMarkdown variant="body1">
        {markdownContent.rawMarkdownBody}
      </StyledMarkdown>
    </ContentText>
  );
};
export default BlockText;
